import React from "react";
import { Link } from "react-router-dom";
import HeroArchway from "./HeroArchway";
import { openCalendly } from "../../lib/calendly";

const GATE_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/gctecocf_ChatGPT%20Image%202026.%20j%C3%BAn.%2024.%2013_46_43.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-24 md:pt-28 pb-6 md:pb-8 px-6 md:px-10"
    >
      <div className="max-w-5xl mx-auto text-center">
        {/* Eyebrow */}
        <p
          data-testid="hero-eyebrow"
          className="fade-in delay-1 text-[12px] tracking-[0.35em] uppercase text-gold mb-5 font-body"
        >
          — Belső utazás önmagadhoz
        </p>

        {/* Title — centered */}
        <h1
          data-testid="hero-title"
          className="fade-in delay-2 font-serif-display text-[42px] sm:text-5xl md:text-[60px] leading-[1.08] text-graphite mb-8"
        >
          Minden kapcsolat hordoz valamilyen{" "}
          <em className="text-gold" style={{ fontStyle: "italic" }}>
            ajándékot
          </em>
          .
        </h1>

        {/* The gate — photographic, framed */}
        <figure className="fade-in delay-2 mt-4 mb-10 md:mb-12">
          <div className="portrait-frame relative max-w-xl mx-auto">
            <img
              data-testid="hero-gate"
              src={GATE_IMAGE_URL}
              alt="A kapu — a belső utazás küszöbe"
              className="w-full h-auto object-cover block"
              style={{
                aspectRatio: "1 / 1",
                filter: "saturate(0.96) contrast(1.02)",
              }}
              loading="eager"
            />
          </div>
        </figure>

        {/* Flowing prose */}
        <div
          data-testid="hero-body"
          className="fade-in delay-3 reading-prose text-[16px] md:text-[17px] leading-[1.85] text-graphite font-body font-light"
        >
          <p>
            Még az általunk legnehezebbnek ítélt kapcsolatok is — sőt, gyakran épp ezek
            hordozzák a legnagyobb ajándékot: segítenek, lökdösnek, hogy elinduljunk a
            valódi önmagunk felé.
          </p>
        </div>

        {/* Pulled-out highlight — clean, no decorative rules */}
        <div
          data-testid="hero-highlight"
          className="fade-in delay-3 my-6 md:my-8"
        >
          <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-graphite max-w-xl mx-auto text-center">
            A kapcsolat a kapu. Az ajándék pedig a{" "}
            <span className="text-gold">felismerés</span>.
          </p>
        </div>

        {/* Question highlight — clean, no rules */}
        <div className="fade-in delay-3 mt-2 md:mt-3 mb-8 md:mb-10 text-center">
          <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-gold max-w-xl mx-auto">
            Készen állsz belépni a kapun és elindulni egy belső utazáson a valódi önmagad
            felé?
          </p>
        </div>

        <div className="fade-in delay-3 reading-prose text-[16px] md:text-[17px] leading-[1.85] text-graphite font-body font-light">
          <p>
            A felismerések hozzák a változást és az új energetikai tér átrendeződését. Nem
            mindig a körülményeink változnak meg először; néha elég egy új nézőpont, hogy
            olyan lehetőségek váljanak láthatóvá, amelyeket addig észre sem vettünk.
          </p>
        </div>

        {/* CTA — centered */}
        <div className="fade-in delay-4 mt-10 flex items-center justify-center gap-6 flex-wrap">
          <button
            type="button"
            onClick={openCalendly}
            data-testid="hero-cta-button"
            className="cta-graphite inline-flex flex-col items-center gap-1 px-10 py-5 font-body font-medium"
          >
            <span className="text-[11px] tracking-[0.3em] uppercase opacity-80">
              Induljunk el együtt
            </span>
            <span className="text-[15px] tracking-[0.2em] uppercase flex items-center gap-3">
              Időpont foglalása
              <span aria-hidden="true">→</span>
            </span>
          </button>
          <span className="flex items-center gap-3 text-[12px] tracking-[0.25em] uppercase text-muted-warm">
            <span className="gold-dot" />
            <span>Egyéni konzultáció</span>
          </span>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 md:mt-10 hairline" />
    </section>
  );
}
